import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-1.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
	textStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard'

const MedicareForHealthProfessionalsStep5Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
          <h1 className={titleStyle}>End of Treatment</h1>
          <div className={textStyle}>
            <p>90266-90269 (continue beyond 30 EDPT services)</p>
            <p>At the end of treatment the mental health provider and the dietitian must provide a report back to the GP. You can find an example template for that report below.</p>

            <p>Patients will be eligible for another EDP with the same therapy and dietetic allowances 12 months after the initiation of the first plan (it does not run by calendar year but rather from the date the plan was issued).</p>

            <p>Patients may continue treatment with their psychological providers and dietitians without an active EDP but the sessions will not be rebated under MBS.</p>
          </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle} style={{display: 'flex' }}>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/psychological-treatment-end-of-treatment-report-template' }
            audiences={ [] }
            title={ 'Psychological Treatment End of Treatment Report Template' }
            body={ 'The psychological treatment provider can use this template for a report back to the medical practitioner following the completion of treatment under the Eating Disorder Care Plan whether this occurs at or before 40 sessions.' }
            date={ '1 Nov, 2019' }
          />
        </div>
      </div>
    </section>
  </div>
);

export { MedicareForHealthProfessionalsStep5Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-health-professionals/step-5.js